// The existing web no longer installs a service worker: the paths it cached now belong to the new
// web, and a cached existing web shell would come back for them offline (docs/web-switch-deploy.md).
// public/sw.js removes itself from browsers that still have it; this removes any registration and
// cache the existing web finds on load.
export async function removeServiceWorkers(
  serviceWorker: Pick<ServiceWorkerContainer, "getRegistrations"> | undefined = typeof navigator === "undefined" ? undefined : navigator.serviceWorker,
  cacheStorage: Pick<CacheStorage, "keys" | "delete"> | undefined = typeof caches === "undefined" ? undefined : caches,
) {
  if (serviceWorker) {
    const registrations = await serviceWorker.getRegistrations().catch(() => []);
    await Promise.all(registrations.map((registration) => registration.unregister().catch(() => false)));
  }

  if (cacheStorage) {
    const cacheKeys = await cacheStorage.keys().catch(() => []);
    await Promise.all(cacheKeys.map((cacheKey) => cacheStorage.delete(cacheKey)));
  }
}

export function unregisterServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }

  window.addEventListener("load", () => {
    void removeServiceWorkers().catch((error) => {
      console.error("Service worker removal failed", error);
    });
  });
}
